import DeleteMemberLocationModal from './DeleteMemberLocationModal.component';

export default DeleteMemberLocationModal;
